import React from 'react';
import AvatarLabel from '../../AvatarLabel';
import DsSelect from '../../DsSelect';
import { formatItemCount } from '../../../../utils/datetime';

export default function ArtistCandidateSelectorPanel({
  title,
  subtitle,
  showTitle = true,
  candidateCount = 0,
  selectedCount = 0,
  keyword = '',
  onKeywordChange,
  keywordPlaceholder = '名前 / メール / プロフィールで絞り込み',
  accountType = 'all',
  onAccountTypeChange,
  groupId = '',
  onGroupIdChange,
  partId = '',
  onPartIdChange,
  groups = [],
  parts = [],
  loadingGroups = false,
  loadingParts = false,
  onSelectAll,
  selectAllDisabled = false,
  selectAllLabel = '表示アーティストをすべて追加',
  onClearSelection,
  clearDisabled = false,
  clearLabel = '選択をクリア',
  loadingCandidates = false,
  candidates = [],
  isSelectedCandidate,
  onToggleCandidate,
  resolveShortPart,
  emptyText = '条件に一致するアーティストがいません。',
  onConfirm,
  confirmLabel = '選択を確定',
  confirmDisabled = false,
}) {
  return (
    <>
      <div className="group-chat-page__modalHead">
        <div>
          {showTitle ? <h2>{title}</h2> : null}
          <p className="group-chat-page__modalSub">{subtitle}</p>
        </div>
        <div className="group-chat-page__modalHeadMeta">
          <span className="group-chat-page__createArtistModalCount">
            候補: {formatItemCount(candidateCount)} / 選択: {formatItemCount(selectedCount)}
          </span>
        </div>
      </div>

      <div className="group-chat-page__createArtistModalFilter">
        <input
          type="text"
          value={keyword}
          onChange={(event) => onKeywordChange?.(event.target.value)}
          placeholder={keywordPlaceholder}
        />
      </div>

      <div className="group-chat-page__createArtistModalFilterGrid">
        <label>
          種別
          <DsSelect value={accountType} onChange={(event) => onAccountTypeChange?.(event.target.value)}>
            <option value="all">すべて</option>
            <option value="solo">ソロ</option>
            <option value="group">グループ</option>
          </DsSelect>
        </label>
        <label>
          グループ
          <DsSelect
            value={groupId}
            onChange={(event) => onGroupIdChange?.(event.target.value)}
            disabled={loadingGroups}
          >
            <option value="">すべて</option>
            {groups.map((group) => (
              <option key={group.group_id} value={group.group_id}>
                {group.group_name}
              </option>
            ))}
          </DsSelect>
        </label>
        <label>
          パート
          <DsSelect
            value={partId}
            onChange={(event) => onPartIdChange?.(event.target.value)}
            disabled={loadingParts}
          >
            <option value="">すべて</option>
            {parts.map((part) => (
              <option key={part.value} value={part.value}>
                {part.label || part.value}
              </option>
            ))}
          </DsSelect>
        </label>
      </div>

      <div className="group-chat-page__createArtistModalActions">
        <button
          type="button"
          className="group-chat-page__openArtistModalButton"
          onClick={onSelectAll}
          disabled={selectAllDisabled}
        >
          {selectAllLabel}
        </button>
        <button
          type="button"
          className="group-chat-page__createArtistClearButton"
          onClick={onClearSelection}
          disabled={clearDisabled}
        >
          {clearLabel}
        </button>
      </div>

      <div className="group-chat-page__createArtistCandidateList">
        {loadingCandidates ? (
          <div className="group-chat-page__miniEmpty">読み込み中...</div>
        ) : candidates.length > 0 ? (
          candidates.map((artist) => {
            const artistId = String(artist?.artist_id || '').trim();
            const checked = !!isSelectedCandidate?.(artist);
            const shortPart = resolveShortPart?.(artist) || '';
            const artistName = artist.name || artist.name_en || '名称未設定';
            const statusLabel = String(artist?.statusLabel || artist?.status_label || '').trim();
            return (
              <button
                key={artistId || artistName}
                type="button"
                className={`group-chat-page__createArtistCandidateChip${
                  checked ? ' is-selected' : ''
                }`}
                onClick={() => onToggleCandidate?.(artist)}
                aria-pressed={checked}
              >
                <span className="group-chat-page__candidateIdentity">
                  <AvatarLabel
                    name={artistName}
                    gender={artist?.gender}
                    imageKey={artist?.profile_picture}
                    shortPart=""
                    topBadge={shortPart || null}
                    topBadgeClassName="group-chat-page__candidatePartBadge"
                    size="sm"
                    className="group-chat-page__candidateAvatarLabel"
                  />
                </span>
                {statusLabel ? (
                  <span className="status-label status-label--danger group-chat-page__candidateStatusLabel">
                    {statusLabel}
                  </span>
                ) : null}
                {checked ? <span className="group-chat-page__createArtistCandidateCheck">✓</span> : null}
              </button>
            );
          })
        ) : (
          <div className="group-chat-page__miniEmpty">{emptyText}</div>
        )}
      </div>

      <div className="group-chat-page__modalActions">
        <button type="button" onClick={onConfirm} disabled={confirmDisabled}>
          {confirmLabel}
        </button>
      </div>
    </>
  );
}
